export default {
  beforeEach(to, from, store) {
    let method = "_before_" + to.name;
    this[method](store);
  },

  _before_clearPass(store) {
    store.menuVisible = "";
    store.breadcrumbVisible = false;
    return ["all"];
  },

  _before_udawajPage(store) {
    store.menuVisible = "";
    store.breadcrumbVisible = false;
    return ["all"];
  },

  _before_searchPage(store) {
    store.menuVisible = "filter";
    store.breadcrumbPath = [{ title: "Szukaj", route: null }];
    store.breadcrumbVisible = true;
  },

  _before_welcomePage(store) {
    store.menuVisible = "mobile";
    store.breadcrumbPath = [];
    store.breadcrumbVisible = false;
    store.showRightWindow = false;
  },

  _before_cart(store) {
    store.menuVisible = "filter";
    store.breadcrumbPath = [{ title: "Koszyk", route: null }];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_productPage(store) {
    store.menuVisible = "filter";
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_orderForm(store) {
    store.menuVisible = "";
    store.breadcrumbPath = [
      { title: "Koszyk", route: "/cart" },
      { title: "Twoje zamówienie", route: null }
    ];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_showPage(store) {
    store.menuVisible = "";
    store.breadcrumbPath = [];
    store.breadcrumbVisible = false;
    store.showRightWindow = false;
  },

  _before_contact(store) {
    store.menuVisible = "";
    store.breadcrumbPath = [];
    store.breadcrumbVisible = false;
    store.showRightWindow = false;
  },

  _before_mainPage(store) {
    store.menuVisible = "";
    store.breadcrumbPath = [];
    store.breadcrumbVisible = false;
    store.showRightWindow = false;
  },

  _before_userRestorePassword(store) {
    store.menuVisible = "";
    store.breadcrumbPath = [];
    store.breadcrumbVisible = false;
    store.showRightWindow = false;
  },

  _before_account(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [{ title: "Ustawienia konta", route: null }];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_addresses(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [{ title: "Adresy dostawy", route: null }];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_addAddress(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [
      { title: "Adresy dostawy", route: "/account/addresses" },
      { title: "Dodaj adres dostawy", route: null }
    ];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_users(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [{ title: "Lista użytkowników", route: null }];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_user(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [{ title: "Nowy użytkownik", route: null }];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_orders(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [{ title: "Lista zamówień", route: null }];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_orderPage(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [
      { title: "Lista zamówień", route: "/account/orders" },
      { title: "Zamówienie nr " + this.orderId, route: null }
    ];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_budgets(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [{ title: "Budżety", route: null }];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_invoices(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [{ title: "Faktury", route: null }];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_addBudget(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [
      { title: "Budżety", route: "/account/budgets" },
      { title: "Dodaj budżet", route: null }
    ];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_mpks(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [
      { title: "Miejsca powstawania kosztów", route: null }
    ];

    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_addMpk(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [
      { title: "Miejsca powstawania kosztów", route: "/account/mpks" },
      { title: "Dodaj MPK", route: null }
    ];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_settings(store) {
    store.menuVisible = "account";
    store.breadcrumbPath = [{ title: "Ustawienia", route: null }];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },
  _before_returnsPage(store) {
    store.breadcrumbPath = [
      { title: "Zwroty i reklamacje", route: "/returns" }
    ];
    store.breadcrumbVisible = true;
  }
};



// WEBPACK FOOTER //
// ./src/router/RouterEvent.js